import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { useApolloClient } from "@apollo/client";

import "../css/App.css";
import "../css/Button.css";
import { loginRequest } from "../authConfig";
import LoginPanel from "./LoginPanel";
import RootView from "./../views/RootView";

export const authenticationChannel = new BroadcastChannel("authentication-channel");
export const LOGOUT_EVENT = "LOGOUT";

export default function Root() {

    const isAuthenticated = useIsAuthenticated();
    const { instance, accounts } = useMsal();
    const account = accounts[0];
    const navigate = useNavigate();
    const client = useApolloClient();

    useEffect(() => {
        const handleAuthenticationEvent = (event) => {
            if (event.data.type === LOGOUT_EVENT) {
                instance.logoutPopup({
                    account
                }).then(() => {
                    client.clearStore();
                    navigate("/");
                    console.log("Logged out from another tab");
                }).catch(error => {
                    console.error("Logout failed:", error);
                });
            } else {
                console.warn("Unknown event type:", event?.data?.type);
            }
        };

        authenticationChannel.addEventListener("message", handleAuthenticationEvent);

        return () => {
            authenticationChannel.removeEventListener("message", handleAuthenticationEvent);
        };
    }, [accounts, client, instance, navigate]);

    const handleLogin = async () => {
        console.log("Logging in...");
        try {
            await instance.loginRedirect(loginRequest);
            console.log("Logged in");
        } catch (error) {
            console.error("Login failed:", error);
        }
    }

    const handleLogout = async () => {
        console.log("Logging out");
        try {
            await instance.logoutPopup({ account });
            authenticationChannel.postMessage({type: LOGOUT_EVENT});
            client.clearStore();
            navigate("/");
            console.log("Logged out");
        } catch (error) {
            console.error("Logout failed:", error);
        }
    }

    return (
        <>
            {isAuthenticated && <RootView onLogoutClicked={handleLogout} />}
            {!isAuthenticated && <LoginPanel onLoginClicked={handleLogin} />}
        </>
    );
}
